import { Routes, RouterModule } from '@angular/router';
import { environment as env } from 'environments/environment';
//Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

//SAMPLE CONDITIONAL ROUTING
export const No_Auth_Routes: Routes = [
  {
    path: 'register',
    loadChildren: () => {

      // Retrieved Projects From Services Based on Hostname
      let Project = ''

      if (location.hostname.toLowerCase().indexOf('app.cpp.org.cy') > -1 || env.DevelopProject.toLowerCase() === 'CPP') {
        Project = 'cpp'
      } else if (location.hostname.toLowerCase().indexOf('cpp.app.cspcom.com') > -1 || env.DevelopProject.toLowerCase() === 'CPP') {
        Project = 'cpp'
      } else if (location.hostname.toLowerCase().indexOf('registration.appadvisory.eu') > -1 || env.DevelopProject.toLowerCase() === 'AppAuditors') {
        Project = 'appauditors'
      } else { //TODO : ???? if module does not exist for default i.e APP Register
        Project = env.DevelopProject
      }

      //  if (location.hostname.toLowerCase().indexOf('localhost') > -1) {
      //     Project = 'APP'
      //  }          

      switch (Project) {
        case 'cpp':
          console.log('CPP Project')
          return import('../../+cpp/registration/registration.module').then(m => m.RegistrationModule);
        case 'appauditors':
          console.log('App Auditors Project Registration')
          return import('../../+appauditors/registration/registration.module').then(m => m.RegistrationModule);
        default:
          console.log('APP Project') //TODO : ???? if module does not exist for default i.e APP Register
          return import('../../+cpp/registration/registration.module').then(m => m.RegistrationModule);
      }

    }
  },
  {
    path: 'verify',
    loadChildren: () => {

      // Retrieved Projects From Services Based on Hostname
      let Project = ''

      if (location.hostname.toLowerCase().indexOf('verification.appadvisory.eu') > -1 || env.DevelopProject === 'AppAuditors') {
        Project = 'appauditors'
      }

      switch (Project) {
        case 'appauditors':
          console.log('App Auditors Project Verification')
          return import('../../+appauditors/verification/verification.module').then(m => m.VerificationModule);
        default:
          console.log('APP Project') //TODO : ???? if module does not exist for default i.e APP Register
          return import('../../+appauditors/verification/verification.module').then(m => m.VerificationModule);
      }

    }
  },
  {
    path: 'menu',
    loadChildren: () => {

      // Retrieved Projects From Services Based on Hostname
      let Project = ''

      if (location.hostname.toLowerCase().indexOf('epos.parco.com.cy') > -1) {
        Project = 'epos'
      }

      if (location.hostname.toLowerCase().indexOf('menu.parco.com.cy') > -1) {
        Project = 'epos-menu'
      }

      if (location.hostname.toLowerCase().indexOf('epos.app.cspcom.com') > -1) {
        Project = 'epos'
      }

      //  if (location.hostname.toLowerCase().indexOf('localhost') > -1) {
      //     Project = 'APP'
      //  }          

      switch (Project) {
        case 'epos-menu':
          console.log('Epos Menu Project')
          return import('../../+epos/menu/epos-menu.module').then(m => m.ePOSMenuModule);
        default:
          console.log('APP Project') //TODO : ???? if module does not exist for default i.e APP Register
          return import('../../+epos/menu/epos-menu.module').then(m => m.ePOSMenuModule);
      }

    }
  }


];

